import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { store, persistor } from './store/configureStore';
import Providers from './providers/Providers';
import AuthProvider from './hooks/useAuth';
import AppRoutes from './routes/AppRoutes';
import './App.css';
import './index.css';
import './styles/base.scss';
import './styles/layout/main.scss';
import './styles/layout/header.scss';
import './styles/layout/footer.scss';
import './styles/components/login-modal.scss';
import './styles/components/breadcrumb.scss';
import './styles/components/banner.scss';
import './styles/components/mobile-app-prompt.scss';
import './styles/pages/home.scss';
import './styles/pages/auth.scss';
import './styles/pages/about.scss';
import './styles/pages/careers.scss';
import './styles/pages/blog.scss';
import './styles/pages/contact.scss';
import './styles/pages/profile.scss';
import './styles/pages/history.scss';
import './styles/pages/support.scss';
import './styles/pages/driver-partners.scss';
import './styles/pages/insurance.scss';
import './styles/pages/press.scss';
import './styles/pages/booking.scss';
import './styles/pages/bider-list.scss';
import './styles/ui/components.scss';
import './styles/ui/mobile-input.scss';
import ScrollToTop from './Components/common/ScrollToTop';
import MobileAppPrompt from './Components/common/MobileAppPrompt';
import { BASENAME } from './utils/environment';

// Create Pusher context for web compatibility
export const PusherContext = React.createContext(null);

const App: React.FC = () => {
  useEffect(() => {
    // Initialize any web-specific configurations
    console.log('LeChalo Web App initialized');
  }, []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <PusherContext.Provider value={null}>
          <Providers>
            <Router basename={BASENAME}>
              <ScrollToTop />
              <AuthProvider>
                <div className="App">
                  <AppRoutes />
                  <MobileAppPrompt />
                </div>
              </AuthProvider>
            </Router>
          </Providers>
        </PusherContext.Provider>
      </PersistGate>
    </Provider>
  );
};

export default App;
